module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-inline position-relative"
  }, [_c('div', {
    staticClass: "d-inline"
  }, [(!_vm.value.changeStatusTo) ? _c('span', {
    staticClass: "lightest radius-normal px-2 py-1",
    class: _vm.getReservationState(_vm.value.status).cssClass
  }, [_vm._v("\n            " + _vm._s(_vm.getReservationState(_vm.value.status).label) + "\n            "), (_vm.getReservationState(_vm.value.status).allowChange && !_vm.disabled) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleShowOptions($event)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-arrow-bottom"
  })]) : _vm._e()]) : _c('span', {
    staticClass: "lightest radius-normal px-2 py-1",
    class: _vm.getReservationState(_vm.value.changeStatusTo).cssClass
  }, [_vm._v("\n            " + _vm._s(_vm.getReservationState(_vm.value.changeStatusTo).label) + "\n            "), (_vm.getReservationState(_vm.value.changeStatusTo).allowChange) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleShowOptions($event)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-arrow-bottom"
  })]) : _vm._e()]), _vm._v(" "), (_vm.getReservationState(_vm.value.status).extraLabel) ? _c('span', {
    staticClass: "ml-1",
    class: {
      'underlined pointer': _vm.getReservationState(_vm.value.status).clickAction
    },
    on: {
      "click": function($event) {
        _vm.getReservationState(_vm.value.status).clickAction ? _vm.getReservationState(_vm.value.status).clickAction(_vm.openReservation) : ''
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.getReservationState(_vm.value.status).extraLabel(_vm.value, _vm.formatTicketNumber)) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.optionsHolderOpen) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.toggleShowOptions),
      expression: "toggleShowOptions"
    }],
    staticClass: "optionsHolder radius-normal p-2 border-light"
  }, _vm._l((_vm.getAllReservationStates), function(option, id) {
    return (option.isOption) ? _c('div', {
      staticClass: "lightest radius-normal px-2 py-1 mb-2 text-center pointer",
      class: option.cssClass,
      on: {
        "click": function($event) {
          return _vm.selectOption(option, option.code)
        }
      }
    }, [_vm._v("\n        " + _vm._s(option.label))]) : _vm._e()
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-74900ffa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74900ffa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/reservation/changeStatusBtn.vue
// module id = 1156
// module chunks = 0